export default __webpack_public_path__ + "static/media/steve cohen.f492b3ac.jpg";